module.exports = __webpack_public_path__ + "static/christianacare-346eaa38bb8dac57d5583985adc2e629.png";